export default __webpack_public_path__ + "static/media/apollo_desktop.7becbe31.jpg";